import { Shield, Award, Clock, Users } from 'lucide-react';

export const TrustBar = () => {
  const trustItems = [
    { icon: Clock, text: '30 Years', subtext: 'of Expertise' },
    { icon: Shield, text: 'Licensed', subtext: '& Insured' },
    { icon: Award, text: '100%', subtext: 'Satisfaction' },
    { icon: Users, text: 'Texas-Based', subtext: 'Local Team' },
  ];

  return (
    <section 
      data-testid="trust-bar" 
      className="bg-off-white py-8 border-y border-tan/20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4">
          {trustItems.map((item, index) => (
            <div 
              key={index}
              className="flex items-center justify-center md:justify-start space-x-3 group"
              data-testid={`trust-item-${index}`}
            >
              <div className="w-12 h-12 bg-navy/5 flex items-center justify-center group-hover:bg-copper/10 transition-colors">
                <item.icon className="w-5 h-5 text-copper" />
              </div>
              <div>
                <p className="font-playfair font-bold text-navy text-lg leading-none">
                  {item.text}
                </p>
                <p className="text-navy/60 font-inter text-xs uppercase tracking-wide mt-0.5">
                  {item.subtext}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
